document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-carousel__list').forEach(function (el) {
    var carousel = el.closest('.product-carousel');

    var swiper = new Swiper(el, {
      slidesPerView: 1.8,
      slidesPerGroup: 1,
      spaceBetween: 12,
      speed: 500,
      breakpoints: {
        1025: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
      },
    });

    if (carousel) {
      carousel.querySelectorAll('.product-carousel__control').forEach(function (btn) {
        btn.addEventListener('click', function () {
          swiper.slideNext();
        });
      });
    }
  });
});
